import { UntypedFormControl, ValidatorFn, Validators } from '@angular/forms';

export class CustomValidators {

  /** Start Number Validation
   *
   * check for valid number ::: CustomValidators.number()
   * check for valid number and min value :: CustomValidators.number({min: 0})
   *  check for valid number and max value :: CustomValidators.number({max: 20})
   * check for valid number and value range ie: [0-20] ::  CustomValidators.number({min: 0, max: 20})
   *
   */
  static number(prms: { min?: number, max?: number } = {}): (control: UntypedFormControl) => { [key: string]: string } {
    const obj: { [key: string]: any } = {};
    obj['number'] = true;
    return (control: UntypedFormControl): { [key: string]: string } => {

      // if (isPresent(Validators.required(control))) {
      //   return null;
      // }

      const val: number = control.value;

      // if (isNaN(val) || /\D/.test(val.toString())) {
      //   return obj;
      // }
      if (prms.min && !isNaN(prms.min) && prms.max && !isNaN(prms.max)) {

        return val < prms.min || val > prms.max ? obj : {};
      }
      else if (prms.min && !isNaN(prms.min)) {

        return val < prms.min ? obj : {};
      } else if (prms.max && !isNaN(prms.max)) {

        return val > prms.max ? obj : {};
      } else {

        return {};
      }
    };
  }

}


export const phoneNumberValidator = '(255|0)([0-9]{9})$';
export const phoneNumberPredixValidator = '([0-9]{9})$';
export const ninValidator = '([0-9]{20})$';
export const validNumberRegex = '^[0-9]*$';
export const tinValidator = '([0-9]{9})$';

export const REQUIRED_VALIDATOR = {
  name: 'required',
  message: 'This field is required',
  validator: Validators.required,
};
export const NUMBER_VALIDATOR = {
  name: 'number',
  message: 'Invalid  Number',
  validator: Validators.pattern(validNumberRegex)
};
export const TIN_NUMBER_VALIDATOR = {
  name: 'number',
  message: 'Invalid TIN Number',
  validator: Validators.pattern(tinValidator)
};

export const TZ_NUMBER_VALIDATOR = {
  name: 'number',
  message: 'Invalid Phone Number',
  validator: Validators.pattern(phoneNumberValidator)
};

export const PREFIX_TZ_NUMBER_VALIDATOR = {
  name: 'number',
  message: 'Invalid Phone Number',
  validator: Validators.pattern(phoneNumberPredixValidator)
};

export const NIN_VALIDATOR = {
  name: 'nin',
  message: 'Invalid NIDA Number',
  validator: Validators.pattern(ninValidator)
};

export const EMAIL_VALIDATOR = {
  name: 'email',
  message: 'Invalid Email',
  validator: Validators.email
};

export const BARUA_PEPE_VALIDATOR = {
  name: 'email',
  message: 'Barua pepe sio sahihi',
  validator: Validators.email
};

export const PASSPORT_VALIDATOR = {
  name: 'passport',
  message: 'Invalid Passport Number',
  validator: Validators.pattern(/^[A-Z0-9]{6,9}$/i)
};
